import React from 'react'
import { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';

import "./LandingPage.css"

import logo from '../assets/images/logo.png'
import head from '../assets/images/Group.png'
import icon1 from '../assets/images/icon1.png'
import icon2 from '../assets/images/icon2.png'
import icon3 from '../assets/images/icon3.png'
import icon4 from '../assets/images/icon4.png'
import icon5 from '../assets/images/icon5.png'
import icon6 from '../assets/images/icon6.png'

import img1 from '../assets/images/nih.png'
import img2 from '../assets/images/harvard.png'
import img3 from '../assets/images/stanford.png'
import img4 from '../assets/images/icgeb.png'
import img5 from '../assets/images/ds.png'
import img6 from '../assets/images/kpmg.png'
import img7 from '../assets/images/jamia.png'
import Slide from '../components/Slideshow/slideshow'
import AutoCarousel from '../components/Carousel/carousel'

import comma from '../assets/images/Comma.png'


import Popup from '../components/Popup/popus'
import Popups from '../components/Popup/popup2'

const images = [img1, img2, img3, img4, img5, img6, img7];
const finalText = "RDX";
const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

const Icon = ({ src, label, visible }) => (
    <div
      className={`flex flex-col w-[200px] h-[160px] items-center p-2 transition-all duration-700 ease-out transform ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      } hover:scale-105`}
    >
      <img
        src={src}
        alt={label}
        loading="lazy"
        className="w-[100px] h-[80px] mb-2 object-contain"
      />
      <p className="text-center w-[160px] text-[14px] leading-[20px]">{label}</p>
    </div>
  );
  

const IconSection = () => {
  const icons = [
    { src: icon1, label: 'Patient Profiling' },
    { src: icon2, label: 'Smart EHR Phenotyping' },
    { src: icon3, label: 'Genetic Risk Assessment' },
    { src: icon4, label: 'AI Assisted Differential Diagnosis' },
    { src: icon5, label: 'Rare Disease Insights' },
    { src: icon6, label: 'Phenotype to Genotype Correlation' },
  ];

  const containerRef = useRef(null);
  const [visibleIndexes, setVisibleIndexes] = useState([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          icons.forEach((_, i) => {
            setTimeout(() => {
              setVisibleIndexes((prev) => [...prev, i]);
            }, i * 150); // staggered animation delay
          });
        }
      },
      { threshold: 0.3 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, []);

  return (
    <div className="flex flex-wrap px-6 pb-6 gap-y-6 gap-x-4 justify-center" ref={containerRef}>
      {icons.map((icon, index) => (
        <Icon key={index} {...icon} visible={visibleIndexes.includes(index)} />
      ))}
    </div>
  );
};




const FadeInSection = () => {
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                    }
                });
            },
            { threshold: 0.8 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    return (
        <div
            ref={sectionRef}
            className={`${isVisible ? 'fadeInUp' : ''
                } animated text-[38px] text-[#1E3A8A] leading-[42px] font-semibold text-center`}
        >
            <h2>
                For Experts By Experts
            </h2>
            <p className="mt-4 text-[18px]">
                Developed by experts in genetics, bioinformatics, and AI with cumulative experience of over 90 years from renowned institutes.
            </p>
        </div>
    );
};
const Stream = () => {
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    return (
        <div
            ref={sectionRef}
            className={`${isVisible ? 'fadeInUp' : ''
                } animated text-[38px] text-[#1E3A8A] leading-[42px] font-semibold text-center`}
        >

            <h1 className='mx-auto text-[38px]'>Streamline rare diseases diagnosis with integrated workflows</h1>
            <p className='mt-4 text-[18px]'>RDX streamlines patient care from intake to diagnosis and personalized treatment and management planning.</p>

        </div>
    );
};

const ShriyanshMessagePopup = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            {
                threshold: 0.75,
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    const togglePopup = () => {
        setShowPopup(!showPopup);
    };

    return (
        <div className="flex justify-center mt-20 py-8" ref={sectionRef}>
            {/* Main Section */}
            <div
                className={`flex justify-between w-[1200px] h-auto rounded-[20px] bg-[#fff] transition-transform duration-700 ease-in-out ${isVisible ? 'slide-in' : 'opacity-0 translate-x-10'}`}

            >
                <div className="flex flex-col justify-between w-full">
                    <div className="flex flex-row justify-between my-6 w-auto">
                        <img
                            src="https://en-media.thebetterindia.com/uploads/2021/08/WhatsApp-Image-2021-08-26-at-4.10.04-PM-2.jpeg"
                            alt="Shriyansh Srivastava"
                            className="w-[430px] h-[460px] items-center mt-6 cursor-pointer rounded rounded-xl"
                            onClick={togglePopup}
                        />
                        <div className="flex justify-center items-center flex-col ml-4">
                            <h2 className="text-[32px] text-[#1E3A8A] leading-[42px] font-semibold text-center w-500px mt-2 mb-4">
                                Shriyansh's Message
                            </h2>
                            <div className='w-full ml-6'>
                                <img src={comma} alt="comma" className='h-[40px] inline' />
                                <img src={comma} alt="comma" className='h-[40px] inline' />
                            </div>
                            <h3 className="text-[20px] text-[#14B8A6] leading-[26px] font-medium text-center px-12 mt-2 w-[800px]">
                                I was diagnosed with Facioscapulohumeral Muscular Dystrophy (FSHD) at a young age, and over the years, I've seen how this condition has affected the muscles in my face, shoulders, and upper arms. While living with FSHD has its challenges, it has also taught me resilience and the value of support from my family, friends, and healthcare team.
                                <br /> <br />
                                "Every day may come with its own set of difficulties, but I remain determined not to let FSHD define me. I believe that by raising awareness and supporting research, we can make a difference for others facing this condition. My journey is ongoing, but I'm committed to living a fulfilling life and helping others do the same."
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};



const MissionSection = () => {
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            {
                threshold: 0.75,
            }
        );
        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    return (
        <div
            ref={sectionRef}
            className={`flex justify-center items-center bg-[#1e3a8a] ${isVisible ? 'fadein-from-right' : 'opacity-0 translate-x-10'
                }`}
        >
            <div className="flex flex-col justify-center px-10 py-14">
                <p className="text-center text-[#fff] leading-[34px]">
                    Our mission is to ensure that every patient, regardless of the rarity
                    of their condition, receives timely diagnosis and early intervention
                    for better health outcomes and an improved quality of life.
                </p>

                <div className="flex justify-center">
                <button
  style={{
    padding: '1rem 2rem',
    borderRadius: '16px',
    fontWeight: 600,
    color: 'white',
    backgroundColor: '#ea580c',
    textAlign: 'center',
    display: 'inline-block',
    cursor: 'pointer',
    width: '130px',
    marginTop: '2rem'
  }}
>
  Join Us
</button>
                </div>
            </div>
        </div>
    );
};







const Footer = () => {
    const footerLinks = [
        {
            title: "Product",
            links: ["Features", "Pricing", "Case Studies", "Resources", "Updates"]
        },
        {
            title: "Company",
            links: ["About Us", "Careers", "Press", "News", "Contact"]
        },
        {
            title: "Legal",
            links: ["Terms of Service", "Privacy Policy", "Cookie Policy", "Disclaimer"]
        }
    ];

    return (
        <footer className="bg-white pt-20 pb-10 px-6">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
                    <div className="space-y-6">
                        <img
                            src={logo}
                            alt="RDx Logo"
                            className="w-30 h-8"
                        />
                        <p className="text-gray-600 text-sm text-start">
                            Empowering healthcare professionals with AI-driven solutions for rare disease diagnosis.
                        </p>
                        <div className="flex space-x-4">
                            <a href="#" className="text-blue-900 hover:text-orange-500 transition-colors">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z" />
                                </svg>
                            </a>
                            <a href="#" className="text-blue-900 hover:text-orange-500 transition-colors">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                                </svg>
                            </a>
                            <a href="#" className="text-blue-900 hover:text-orange-500 transition-colors">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                                </svg>
                            </a>
                        </div>
                    </div>

                    {footerLinks.map((section, index) => (
                        <div key={index}>
                            <h3 className="font-semibold text-blue-900 mb-4 text-start">{section.title}</h3>
                            <ul className="space-y-3">
                                {section.links.map((link, i) => (
                                    <li key={i}>
                                        <a href="#" className="text-gray-600 hover:text-orange-500 transition-colors text-sm">
                                            {link}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

            </div>
        </footer>
    );
};


export default function LandingPage() {
    const navigate = useNavigate();
    const [showIntro, setShowIntro] = useState(true);
    const [displayText, setDisplayText] = useState("");
    const [iteration, setIteration] = useState(0);
    const [isFading, setIsFading] = useState(false);
    const [showPoweredBy, setShowPoweredBy] = useState(false);

    useEffect(() => {
        if (showIntro) {
            const interval = setInterval(() => {
                setDisplayText((prev) => {
                    let newText = "";
                    for (let i = 0; i < finalText.length; i++) {
                        if (i < iteration) {
                            newText += finalText[i];
                        } else {
                            newText += characters[Math.floor(Math.random() * characters.length)];
                        }
                    }
                    return newText;
                });

                setIteration((prev) => {
                    if (prev >= finalText.length) {
                        clearInterval(interval);
                        setShowPoweredBy(true);
                        setTimeout(() => {
                            setIsFading(true);
                            setTimeout(() => setShowIntro(false), 300);
                        }, 2000);
                    }
                    return prev + 1;
                });
            }, 80); // Faster character changes

            return () => clearInterval(interval);
        }
    }, [iteration, showIntro]);

    return (
        <div className=''>
            {showIntro && (
                <div className={`landing-page-intro-container ${isFading ? 'landing-page-fade-out' : ''}`}>
                    <h1 className="landing-page-intro-text">
                        {displayText}
                    </h1>
                    {showPoweredBy && (
                        <p className="landing-page-powered-by">
                            Powered by Vgenomics
                        </p>
                    )}
                </div>
            )}

            <div className='bg-[#cfe2f1] p-6'>
                <header className='flex justify-between space-x-12 bg-[#cfe2f1] px-4 pt-2 pb-4'>
                    <div className="logo my-auto">
                        <img src={logo} alt="logo" className="w-30 h-8" loading="lazy" />
                    </div>


                    <div className="flex">
                        <ul className="my-auto mr-12 font-medium">
                            <li>
                                <a href="/">About Us</a>
                            </li>

                        </ul>


                        <button
  style={{
    padding: '1rem 2rem',
    borderRadius: '16px',
    fontWeight: 600,
    color: 'white',
    backgroundColor: '#ea580c',
    textAlign: 'center',
    display: 'inline-block',
    cursor: 'pointer'
  }}
>
  Request a Demo
</button>
<button
  style={{
    padding: '1rem 2rem',
    borderRadius: '16px',
    fontWeight: 600,
    color: 'white',
    backgroundColor: '#ea580c',
    textAlign: 'center',
    display: 'inline-block',
    cursor: 'pointer',
    marginLeft: '2rem',
    width: '90px'
  }}
  onClick={() => navigate('/login')}
>
  Login
</button>
                    </div>

                </header>

                <div className='flex py-4 justify-between ml-6'>

                    <div className='w-1/2 mt-2'>
                        <div>
                            <h1 className='text-[#1E3A8A] text-[48px] tracking-tight font-bold leading-[54px] text-start'>RDX: Your Rare Disease Expert</h1>
                            <p className='text-[#1E3A8A] tracking-tighter font-regular my-4 mb-2 text-start text-[18px]'>AI-powered rare diseases diagnosis platform for 4200+ rare diseases</p>
                        </div>
                        <IconSection />
                        <div className="flex justify-start items-start pl-6">
                        <button
  style={{
    padding: '1rem 2rem',
    borderRadius: '16px',
    fontWeight: 600,
    color: 'white',
    backgroundColor: '#ea580c',
    textAlign: 'center',
    display: 'inline-block',
    cursor: 'pointer',
    width: '230px',
    marginTop: '1.5rem'
  }}
  onClick={() => navigate('/login')}
>
  Get Started Today!
</button>
                        </div>
                    </div >


                    <div className='w-[720px] h-[600px] mt-[-20px] ml-4'>
                        <img src={head} alt="image" className='w-full h-[600px]' />
                    </div>
                </div>
            </div>


            <div className='my-14'>

                <FadeInSection />

                <div className='App'>
                    <AutoCarousel images={images} loading="lazy" />
                </div>

            </div>

            <Stream />


            <Popup />


            <Popups />




            <ShriyanshMessagePopup />

            <div className="w-full mt-14">
                <div className="w-full mt-8 ">
                    <Slide />
                </div>
            </div>

            <MissionSection />

            <Footer />

            <div className='mt-30 bg-[#1E3A8A] py-6'>
                <p className="text-center mt-6 text-[18px] text-[#fff]">© 2025 RDx. All rights reserved.
                </p>

                <p className="flex justify-center text-[14px] text-[#fff] text-center mt-2 w-full px-16 py-2">Disclaimer: RDx tool does not provide medical advice. It is intended for informational purposes only. It is not a substitute for professional medical advice, diagnosis or treatment. It does not diagnose, it produces a ranked list of suspected diseases which provide assistance for rare disease cases.</p>
            </div>






        </div >

    )
}